export * from './auth.service';
export * from './library.service';
export * from './sms-course.service';
export * from './course-home.service';
export * from './topic.service';
export * from './playlist.service';
export * from './tag.service';
export * from './video.service';
export * from './video-detail.service';
export * from './course-setting.service';
export * from './book-code.service';
export * from './admin-user.service';
export * from './template.service';
export * from './elastic.service';
export * from './favourite.service';


// WEBPACK FOOTER //
// ./src/_services/index.js